import { render, staticRenderFns } from "./bodyAnalysisPdf.vue?vue&type=template&id=724a70fc&scoped=true&"
import script from "./bodyAnalysisPdf.vue?vue&type=script&lang=js&"
export * from "./bodyAnalysisPdf.vue?vue&type=script&lang=js&"
import style0 from "./bodyAnalysisPdf.vue?vue&type=style&index=0&id=724a70fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a70fc",
  null
  
)

export default component.exports